import RopTable, {
  TableRowType,
} from "../../../../main/components/RopTable/RopTable";
import { numberPtBrPercent0100 } from "../../../../main/utils/utils";
import { ParetoDaily, ParetoDeOcorrenciasNoMes } from "../../types";
import { ocorrenciaChartDataFromAlarms } from "./ParetoReportChart";

export default function ParetoTable(props: {
  data: ParetoDeOcorrenciasNoMes | ParetoDaily;
}) {
  const { data } = props;
  const ocorrenciaChartData = ocorrenciaChartDataFromAlarms(data);

  let tableRows: TableRowType[] | undefined;

  if (ocorrenciaChartData.alarms) {
    tableRows = ocorrenciaChartData.alarms.map((e) => {
      if (e.code === "ALM201") {
        const novaDescricao = "Inversor operando abaixo do esperado";
        return {
          rowItems: [
            {
              item: <>{e.code}</>,
              isMobile: true,
              align: "center",
            },
            {
              item: <>{e.descricao}</>,
              isMobile: false,
              align: "center",
            },
            {
              item: <>{e.duration}</>,
              isMobile: false,
              align: "center",
            },
            {
              item: <>{novaDescricao}</>,
              isMobile: true,
            },
            {
              item: <>{e.amount}</>,
              isMobile: false,
              align: "center",
            },
            {
              item: <>{numberPtBrPercent0100(e.percentage ?? 0, 1)}</>,
              isMobile: false,
              align: "center",
            },
          ],
        };
      } else {
        return {
          rowItems: [
            {
              item: <>{e.code}</>,
              isMobile: true,
              align: "center",
            },
            {
              item: <>{e.descricao}</>,
              isMobile: false,
              align: "center",
            },
            {
              item: <>{e.duration}</>,
              isMobile: false,
              align: "center",
            },
            {
              item: <>{e.name}</>,
              isMobile: true,
            },
            {
              item: <>{e.amount}</>,
              isMobile: false,
              align: "center",
            },
            {
              item: <>{numberPtBrPercent0100(e.percentage ?? 0, 1)}</>,
              isMobile: false,
              align: "center",
            },
          ],
        };
      }
    });
  }
  return (
    <>
      <RopTable
        sxCardBox={{
          height: "100%",
          width: "100%",
          minHeight: "400px",
          display: "flex",
          flexDirection: "column",
          margin: "0px",
        }}
        itemRows={tableRows}
        itemsHeaders={[
          {
            item: "Código",
            align: "center",
          },
          {
            item: "Atuação",
            align: "center",
            isMobile: false,
          },
          {
            item: "Duração",
            align: "center",
            isMobile: false,
          },
          {
            item: "Nome",
            isMobile: true,
          },
          {
            item: "Quantidade",
            align: "center",
            isMobile: false,
          },
          {
            item: "Porcentagem",
            align: "center",
            isMobile: false,
          },
        ]}
      />
    </>
  );
}
